// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29U9k","largestCol":"styles_largestCol__3V9Gy","smallestCol":"styles_smallestCol__1vebb"};